


























































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { filterUrl } from '~/assets/filters/url'
import { ILinkItem } from '~/assets/interfaces/navigation'
import MixinGeneral from '~/assets/mixins/general'
import { CONFIG_LAYOUT_HEADER_INFO_MENU_API } from '~/assets/config/api-path'
import ComponentDropdown from '~/components/dropdown/dropdown.vue'

@Component({
  components: {
    ComponentDropdown,
  },
  filters: {
    filterUrl,
  },
})
export default class ComponentQuickAccessMenu extends mixins(MixinGeneral) {
  @Prop({ type: Boolean }) readonly white!: boolean

  private items: ILinkItem[] | [] = []
  private activeDropdownIndex: number | null = null
  private dropdownTimer = 0

  private async getMenu() {
    this.items =
      (await this.$axios.$get(CONFIG_LAYOUT_HEADER_INFO_MENU_API)) || null
  }

  private async mounted() {
    await this.getMenu()
  }

  private setActiveDropdown(index: number, isOpen: boolean) {
    this.activeDropdownIndex = isOpen ? index : null
  }

  private openDropdown(index: number) {
    clearTimeout(this.dropdownTimer)
    if (this.items[index]?.items?.length) {
      this.activeDropdownIndex = index
    }
  }

  private closeDropdown() {
    this.dropdownTimer = window.setTimeout(() => {
      this.activeDropdownIndex = null
    }, 100)
  }

  private get colorType() {
    return {
      [this.$style.white]: this.white,
      [this.$style.default]: !this.white,
    }
  }
}
